(function(){
'use strict';

const DISCOUNTS={2:5,3:10,4:15};
const MAX_DISC=15;
const CORE_STEPS=['kite','bar','board','harness'];

const wizard=document.getElementById('kit-wizard');
if(!wizard)return;
const kitName=wizard.dataset.kitName;
const stepsEl=document.getElementById('kw-steps-data');
const productDataEl=document.getElementById('kw-product-data');

let steps=[],productData={},currentStep=-1,selections={};

try{
  steps=JSON.parse(stepsEl.textContent);
  productData=JSON.parse(productDataEl.textContent);
  steps.forEach(s=>{selections[s.id]={};});
}catch(e){
  console.error('[KitWizard] Parse error:',e);
  const el=document.getElementById('kw-step-content');
  if(el)el.innerHTML='<p class="kw-error">Error loading kit. Please refresh.</p>';
  return;
}

function countSelected(){
  return steps.filter(s=>s.id!=='bindings'&&selections[s.id]&&selections[s.id].variantId).length;
}

function coreComplete(){
  return CORE_STEPS.every(id=>selections[id]&&selections[id].variantId);
}

function getDiscount(){
  const n=countSelected();
  return n>=4?MAX_DISC:(DISCOUNTS[n]||0);
}

function fmtPrice(cents){
  return '$'+(cents/100).toLocaleString('en-AU',{minimumFractionDigits:0,maximumFractionDigits:0});
}

function hasAvailableVariants(product){
  return product.variants&&product.variants.length>0;
}

function getPriceHtml(product, selVariant, stepId){
  const d=getDiscount();
  const comp=coreComplete();
  const isBindings=stepId==='bindings';
  const isFree=isBindings&&comp;
  const is50=isBindings&&!comp;

  // Base price: use selected variant price or product min
  const basePrice=selVariant?selVariant.price_cents:product.price_cents;
  // Compare at: use selected variant compare_at or product compare_at
  const compareAt=selVariant?(selVariant.compare_at_cents||0):(product.compare_at_cents||0);

  if(isFree){
    // Show compare_at or base, then FREE
    const showOrig=compareAt>basePrice?compareAt:basePrice;
    return`<span class="kw-price-compare">${fmtPrice(showOrig)}</span> <span class="kw-price-sale">Free</span>`;
  }

  if(is50){
    const half=Math.round(basePrice*0.5);
    const showOrig=compareAt>basePrice?compareAt:basePrice;
    return`<span class="kw-price-compare">${fmtPrice(showOrig)}</span> <span class="kw-price-sale">${fmtPrice(half)}</span>`;
  }

  // Regular kit discount logic
  if(d>0){
    const kitPrice=Math.round(basePrice*(1-d/100));
    // Show compare_at if exists, otherwise show base price as original
    if(compareAt>basePrice){
      // Product is on sale AND has kit discount
      return`<span class="kw-price-compare">${fmtPrice(compareAt)}</span> <span class="kw-price-original">${fmtPrice(basePrice)}</span> <span class="kw-price-sale">${fmtPrice(kitPrice)}</span>`;
    } else {
      // Just kit discount
      return`<span class="kw-price-original">${fmtPrice(basePrice)}</span> <span class="kw-price-sale">${fmtPrice(kitPrice)}</span>`;
    }
  }

  // No discount yet
  if(compareAt>basePrice){
    return`<span class="kw-price-compare">${fmtPrice(compareAt)}</span> <span class="kw-price-sale">${fmtPrice(basePrice)}</span>`;
  }
  return fmtPrice(basePrice);
}

function updateDiscountDisplay(){
  const el=document.getElementById('kw-discount-display');
  if(!el)return;
  const n=countSelected(),d=getDiscount();
  if(n<2){el.textContent='add 2+ items to unlock savings';el.classList.remove('active');}
  else{el.textContent=d+'% off your kit';el.classList.add('active');}
}

function updateProgress(){
  const bar=document.getElementById('kw-progress');
  if(!bar)return;
  if(currentStep===-1){bar.innerHTML='';return;}
  bar.innerHTML=Array.from({length:steps.length+1},(_,i)=>{
    let c='kw-progress-step';
    if(i<currentStep)c+=' done';
    else if(i===currentStep)c+=' active';
    return`<div class="${c}"></div>`;
  }).join('');
}

function render(){
  updateProgress();
  updateDiscountDisplay();
  if(currentStep===-1){renderIntro();return;}
  if(currentStep===steps.length){renderSummary();return;}

  const step=steps[currentStep];
  const products=productData[step.id]||[];
  const sel=selections[step.id];
  const comp=coreComplete();
  const isBindings=step.id==='bindings';
  const isFree=isBindings&&comp;
  const is50=isBindings&&!comp;

  let html=`<div class="kw-step-header"><div class="kw-step-label">step ${currentStep+1} of ${steps.length}</div><div class="kw-step-title">${step.title}</div></div>`;

  if(isFree){
    html+=`<div class="kw-free-banner"><span class="kw-free-icon">🎁</span><div><strong>You unlocked free bindings!</strong> Choose your size below.</div></div>`;
  }else if(is50){
    html+=`<div class="kw-info-banner"><span class="kw-free-icon">🏷️</span><div><strong>50% off bindings!</strong> Add a kite, bar, board and harness to unlock free bindings instead.</div></div>`;
  }

  if(products.length===0){
    html+=`<p class="kw-no-products">No products available for this category right now.</p>`;
  }else{
    html+=`<div class="kw-products-grid">`;
    products.forEach(product=>{
      if(!hasAvailableVariants(product))return;
      const isSel=sel&&sel.productId===product.id;
      const selVariant=isSel&&sel.variantId?product.variants.find(v=>v.id===sel.variantId):null;
      const priceHtml=getPriceHtml(product,selVariant,step.id);
      const availableVariants=product.variants.filter(v=>v.available);
      const hasV=availableVariants.length>1;
      const singleV=availableVariants.length===1?availableVariants[0]:null;
      const vOpts=hasV?`<select class="kw-variant-select" data-step="${step.id}" data-pid="${product.id}" onchange="kwOnSelectVariant(this)"><option value="">Select size</option>${availableVariants.map(v=>`<option value="${v.id}" data-price="${v.price_cents}" data-compare="${v.compare_at_cents||0}"${sel&&sel.variantId===v.id?' selected':''}>${v.title}</option>`).join('')}</select>`:'';
      html+=`<div class="kw-product-card${isSel?' selected':''}" data-step="${step.id}" data-pid="${product.id}" onclick="kwOnSelectProduct(event,this)">
        <div class="kw-check"><svg viewBox="0 0 12 12"><polyline points="1.5,6 4.5,9 10.5,3"/></svg></div>
        <a href="${product.url}" target="_blank" onclick="event.stopPropagation()" class="kw-product-link" title="View product">↗</a>
        ${product.image?`<img class="kw-product-img" src="${product.image}" alt="${product.title}" loading="lazy">`:`<div class="kw-product-img-placeholder">📦</div>`}
        <div class="kw-product-info">
          <div class="kw-product-name">${product.title}</div>
          <div class="kw-product-price" id="price-${product.id}">${priceHtml}</div>
          ${vOpts}
          ${singleV&&singleV.title!=='Default Title'?`<div class="kw-single-variant">${singleV.title}</div>`:''}
        </div>
      </div>`;
    });
    html+=`</div>`;
  }

  const isKiteStep=step.id==='kite';
  const canGo=!!(sel&&sel.variantId)||!isKiteStep;
  html+=`<div class="kw-nav">${currentStep>0?`<button class="kw-btn-back" onclick="kwPrev()">← back</button>`:''}<button class="kw-btn-next" id="kw-btn-next" onclick="kwNext()"${canGo?'':' disabled'}>${currentStep===steps.length-1?'review your kit →':'next →'}</button></div>`;
  if(!isKiteStep)html+=`<div class="kw-skip"><button class="kw-skip-link" onclick="kwSkip()">skip this step</button></div>`;
  document.getElementById('kw-step-content').innerHTML=html;
}

function renderIntro(){
  const el=document.getElementById('kw-step-content');
  if(!el)return;
  el.innerHTML=`
    <div class="kw-intro">
      <div class="kw-intro-rules">
        <div class="kw-rule"><span class="kw-rule-badge">5% off</span><span class="kw-rule-text">Choose 2 items</span></div>
        <div class="kw-rule"><span class="kw-rule-badge">10% off</span><span class="kw-rule-text">Choose 3 items</span></div>
        <div class="kw-rule"><span class="kw-rule-badge">15% off</span><span class="kw-rule-text">Choose 4+ items</span></div>
      </div>
      <div class="kw-intro-unlock">
        <div class="kw-unlock-icon">🎁</div>
        <div class="kw-unlock-text">
          <strong>Unlock free bindings</strong>
          <span>Add a kite, bar, board and harness to your kit</span>
        </div>
      </div>
      <div class="kw-intro-unlock kw-unlock-alt">
        <div class="kw-unlock-icon">🏷️</div>
        <div class="kw-unlock-text">
          <strong>50% off bindings</strong>
          <span>Available on any kit, even without completing all four items</span>
        </div>
      </div>
      <button class="kw-btn-start" onclick="kwStart()">Start building your kit →</button>
    </div>
  `;
}

window.kwStart=function(){currentStep=0;render();};

window.kwOnSelectProduct=function(e,cardEl){
  if(e.target.tagName==='SELECT'||e.target.tagName==='OPTION'||e.target.tagName==='A')return;
  const stepId=cardEl.dataset.step;
  const pid=parseInt(cardEl.dataset.pid);
  const step=steps.find(s=>s.id===stepId);
  const product=(productData[stepId]||[]).find(x=>x.id===pid);
  if(!product)return;

  if(selections[stepId].productId===pid){
    selections[stepId]={};
  }else{
    selections[stepId]={productId:pid};
    const availableVariants=product.variants.filter(v=>v.available);
    if(availableVariants.length===1){
      const v=availableVariants[0];
      const price=getVariantPrice(stepId,v.price_cents);
      selections[stepId]={productId:pid,variantId:v.id,variantPrice:price,variantCompareAt:v.compare_at_cents||0,productTitle:product.title,variantTitle:v.title==='Default Title'?null:v.title,stepTitle:step.title};
    }
  }
  render();
};

function getVariantPrice(stepId,basePrice){
  if(stepId==='bindings'){
    return coreComplete()?0:Math.round(basePrice*0.5);
  }
  return basePrice;
}

window.kwOnSelectVariant=function(el){
  const stepId=el.dataset.step;
  const pid=parseInt(el.dataset.pid);
  const vid=parseInt(el.value);
  if(!vid)return;
  const step=steps.find(s=>s.id===stepId);
  const product=(productData[stepId]||[]).find(x=>x.id===pid);
  if(!product)return;
  const v=product.variants.find(x=>x.id===vid);
  if(!v)return;

  const price=getVariantPrice(stepId,v.price_cents);
  selections[stepId]={
    productId:pid,variantId:v.id,variantPrice:price,
    variantCompareAt:v.compare_at_cents||0,
    productTitle:product.title,
    variantTitle:v.title==='Default Title'?null:v.title,
    stepTitle:step.title
  };
  render();
};

window.kwNext=function(){if(currentStep<steps.length)currentStep++;render();};
window.kwPrev=function(){if(currentStep>0)currentStep--;else currentStep=-1;render();};
window.kwSkip=function(){selections[steps[currentStep].id]={};kwNext();};

function renderSummary(){
  updateProgress();updateDiscountDisplay();
  const d=getDiscount(),comp=coreComplete();
  let nonBindingsTotal=0,rows='';

  steps.forEach(step=>{
    const sel=selections[step.id];
    if(!sel||!sel.variantId)return;
    const isBindings=step.id==='bindings';
    const isFree=isBindings&&comp;
    const is50=isBindings&&!comp;
    if(!isBindings)nonBindingsTotal+=sel.variantPrice;

    let priceDisplay;
    if(isFree){
      priceDisplay='<span class="kw-free-badge">FREE</span>';
    }else if(is50){
      priceDisplay=`<span class="kw-price-compare">${fmtPrice(sel.variantPrice*2)}</span> <span class="kw-price-sale">${fmtPrice(sel.variantPrice)}</span>`;
    }else{
      priceDisplay=fmtPrice(sel.variantPrice);
    }

    rows+=`<div class="kw-summary-row">
      <div>
        <div class="kw-summary-item-name">${sel.productTitle}${sel.variantTitle?' — '+sel.variantTitle:''}</div>
        <div class="kw-summary-item-cat">${sel.stepTitle}</div>
      </div>
      <div class="kw-summary-item-price">${priceDisplay}</div>
    </div>`;
  });

  const savings=Math.round(nonBindingsTotal*d/100);
  const bindingsSel=selections['bindings'];
  const bindingsTotal=bindingsSel&&bindingsSel.variantId?bindingsSel.variantPrice:0;
  const total=nonBindingsTotal-savings+bindingsTotal;

  let html=`<div class="kw-step-header"><div class="kw-step-label">your kit</div><div class="kw-step-title">review and add to cart</div></div>`;
  if(comp&&bindingsSel&&bindingsSel.variantId)html+=`<div class="kw-free-banner"><span class="kw-free-icon">🎁</span><div><strong>Complete kit!</strong> Bindings included free.</div></div>`;
  html+=`<div class="kw-summary-rows">${rows}`;
  if(d>0)html+=`<div class="kw-summary-discount-row"><span>Kit discount (${d}%)</span><span>-${fmtPrice(savings)}</span></div>`;
  html+=`<div class="kw-summary-total"><span class="kw-summary-total-label">Total</span><span class="kw-summary-total-price">${fmtPrice(total)}</span></div></div>`;
  if(d>0)html+=`<p style="font-size:13px;color:#666;margin-top:1rem;text-align:center">Discount code KIT${d} will be applied at checkout.</p>`;
  html+=`<button class="kw-btn-back" onclick="kwPrev()" style="margin-top:1rem">← back</button><button class="kw-btn-cart" id="kw-btn-cart" onclick="kwAddToCart()">Add kit to cart</button>`;
  document.getElementById('kw-step-content').innerHTML=html;
}

window.kwAddToCart=function(){
  const btn=document.getElementById('kw-btn-cart');
  if(btn){btn.disabled=true;btn.textContent='Adding to cart...';}
  const comp=coreComplete(),d=getDiscount();
  const items=steps.filter(s=>selections[s.id]&&selections[s.id].variantId).map(s=>{
    const sel=selections[s.id];
    const isBindings=s.id==='bindings';
    const isFree=isBindings&&comp;
    const is50=isBindings&&!comp;
    return{id:sel.variantId,quantity:1,properties:{_kit:kitName,...(isFree?{_free_item:'true'}:{}),...(is50?{_bindings_discount:'50%'}:{}),...(d>0&&!isBindings?{_kit_discount:d+'%'}:{})}};
  });
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})})
    .then(r=>r.json())
    .then(data=>{
      if(data.status)throw new Error(data.description||'Cart error');
      const codeMap={5:'KIT5',10:'KIT10',15:'KIT15'};
      window.location.href=d>0?`/cart?discount=${codeMap[d]}`:'/cart';
    })
    .catch(err=>{
      console.error('[KitWizard]',err);
      if(btn){btn.disabled=false;btn.textContent='Add kit to cart';}
      alert('Something went wrong. Please try again.');
    });
};

render();
})();
